export const POSTHOG_API_KEY = import.meta.env.POSTHOG_API_KEY as string;
export const POSTHOG_BASE_URL = import.meta.env.POSTHOG_BASE_URL as string;

export enum AnalyticsEvent {
  PAGE_VIEW = 'page_view',
  USER_LOG_IN = 'user_log_in',
  USER_LOG_OUT = 'user_log_out',
}
